import React from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { SELECT_PROPS, optionOf } from "./ticketUtils";
import {
    optionsIsuueOld,
    optionsPriority,
} from "../../Frontend/Support/common";

const TicketFilters = ({
    hasMultipleVendors,
    vendorOptions,
    storeOptions,
    statusOptions,
    vendorZohoId,
    hraMemberId,
    status,
    category,
    priority,
    startDate,
    endDate,
    activeFilterCount,
    onVendorChange,
    onStoreChange,
    onStatusChange,
    onCategoryChange,
    onPriorityChange,
    onRangeChange,
    onClear,
}) => (
    <div className="vp-tk-filters">
        {hasMultipleVendors && (
            <div className="vp-tk-ffield">
                <label className="vp-tk-flabel">Vendor</label>
                <Select
                    {...SELECT_PROPS}
                    options={vendorOptions}
                    value={optionOf(vendorOptions, vendorZohoId)}
                    onChange={(option) => onVendorChange(option ? option.value : "")}
                    placeholder="All vendors"
                />
            </div>
        )}

        <div className="vp-tk-ffield">
            <label className="vp-tk-flabel">Store</label>
            <Select
                {...SELECT_PROPS}
                options={storeOptions}
                value={optionOf(storeOptions, hraMemberId)}
                onChange={(option) => onStoreChange(option ? option.value : "")}
                placeholder="All stores"
            />
        </div>

        <div className="vp-tk-ffield">
            <label className="vp-tk-flabel">Status</label>
            <Select
                {...SELECT_PROPS}
                options={statusOptions}
                value={optionOf(statusOptions, status)}
                onChange={(option) => onStatusChange(option ? option.value : "")}
                placeholder="All statuses"
            />
        </div>

        <div className="vp-tk-ffield">
            <label className="vp-tk-flabel">Category</label>
            <Select
                {...SELECT_PROPS}
                options={optionsIsuueOld}
                value={optionOf(optionsIsuueOld, category)}
                onChange={(option) => onCategoryChange(option ? option.value : "")}
                placeholder="All categories"
            />
        </div>

        <div className="vp-tk-ffield">
            <label className="vp-tk-flabel">Priority</label>
            <Select
                {...SELECT_PROPS}
                options={optionsPriority}
                value={optionOf(optionsPriority, priority)}
                onChange={(option) => onPriorityChange(option ? option.value : "")}
                placeholder="Any priority"
            />
        </div>

        <div className="vp-tk-ffield vp-tk-fdate">
            <label className="vp-tk-flabel">Date</label>
            <DatePicker
                selected={startDate}
                onChange={(dates) => {
                    const [start, end] = dates;
                    onRangeChange(start, end);
                }}
                startDate={startDate}
                endDate={endDate}
                selectsRange
                isClearable
                placeholderText="Any date"
                dateFormat="MM/dd/yy"
            />
        </div>

        <div className="vp-tk-factions">
            <button
                type="button"
                className="vp-tk-fclear"
                onClick={onClear}
                disabled={activeFilterCount === 0}
            >
                Clear all
            </button>
        </div>
    </div>
);

export default TicketFilters;
